import mitt from "mitt";
import { Observable } from "rxjs";

export function NotificationModalController() {
    this.busModal = mitt();
    //#region setter
    this.clearModal = function () {
        this.callbackOk = null;
        return this;
    };
    this.setCampaign = function (campaign) {
        this.campaign = campaign
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function (type, data, isEarnReward) {
        return new Observable((sub) => {
            let config = {
                subscriber: sub,
                campaign: this.campaign,
                type,
                data,
                isEarnReward,
            }
            this.busModal.emit('show', config);
        })
    };
    this.hide = function () {
        this.busModal.emit('hide');
    };
    //#endregion method
}
